import { useState, useEffect, useCallback, createContext, useContext } from 'react'
import { useHistory } from 'react-router'
import { toast } from 'react-toastify'
import { useAuth } from '../../../context/AuthContext'
import { api } from '../../../services/api'
import moment from 'moment'

export const AdministrativePanelContext = createContext();

export function AdministrativeProvider({ children }){
  const history = useHistory()
  const { signOut } = useAuth()

  const [businessAdm, setBusinessAdm] = useState([])
  const [listAllBusinessCodes, setListAllBusinessCodes] = useState([])
  const [syncInformations, setSyncInformations] = useState(null)

  const [quantityBusinessToFetch, setQuantityBusinessToFetch] = useState(0)
  const [nextPage, setNextPage] = useState(null)
  const [loadingButtonSeeMore, setLoadingButtonSeeMore] = useState(false)

  const [listBusinessToFilter, setListBusinessToFilter] = useState([])
  const [listSalesChannelsId, setListSalesChannelsId] = useState([])
  const [franchiseList, setFranchiseList] = useState([])
  const [allFranchiseListCodes, setAllFranchiseListCodes] = useState([])
  const [franchiseListCodesSelected, setFranchiseListCodesSelected] = useState([])
  const [informationsFiltered, setInformationsFiltered] = useState(null)
  const [informationsToShowInPage, setInformationsToShowInPage] = useState('dashboard')
  const [radioButton, setRadioButton] = useState(null) 
  
  const [openSideBar, setOpenSideBar] = useState(false)
  const [openSubMenu,setOpenSubMenu] = useState(false);
  const [openDrop,setOpenDrop] = useState(false);

  const [isLoading, setIsLoading] = useState(true)

  const [listDashboardButtons, setListDashboardButtons] = useState([])

  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DDT00:00'))
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DDT23:59'))
  const [typeDateSelected, setTypeDateSelected] = useState(0)

  
  const getBusinessAdm = useCallback(async (fetch = true, qtt) => {
    setLoadingButtonSeeMore(true)
    try{
      const response = await api.get(`/getBusinessAdm?quantity=${qtt}`, {
        headers: {
          token: localStorage.getItem('@Inoveclube:token')
        }
      })

      const { 
        success, 
        business, 
        next_page,
        syncInformations, 
        listAllBusinessCodes,
        salesChannels,
        franchiseList
      } = response.data
      
      if(success){
        const franchiseListCodes = franchiseList.map(franchise => franchise.id)

        setBusinessAdm(business)
        setSyncInformations(syncInformations)
        setListAllBusinessCodes(listAllBusinessCodes)
        setFranchiseList(franchiseList)
        setAllFranchiseListCodes(franchiseListCodes)
        setNextPage(next_page)
      
        if(fetch){
          setRadioButton(0)
          setListBusinessToFilter(listAllBusinessCodes)
          setListSalesChannelsId(salesChannels)
          setFranchiseListCodesSelected(franchiseListCodes)
        }

      }else{
        signOut()
      }

      setLoadingButtonSeeMore(false)
      setIsLoading(false)
    }catch{
      signOut()
      setIsLoading(false)
      setLoadingButtonSeeMore(false)
      toast.error('Algo deu errado, faça o login novamente')
    }
  }, [signOut])
  

  const getDashboardButtons = useCallback(async () => {
    try{
        await api.get('/getPermissions/' + localStorage.getItem('@Inoveclube:token'), {
          headers: {
              token: localStorage.getItem('@Inoveclube:token')
          }
        }).then(response =>{ 
          setListDashboardButtons(response.data)
          response.data.some(data => data === '1') ?
            setInformationsToShowInPage('dashboard')
            :
            setInformationsToShowInPage('home')
        })

      }catch(error){
        if(error.response.status === 401 || error.response.status === 500){
          signOut()
          toast.warning('Sua sessão foi expirada')
        }else{
          toast.error(error.response.data.message)
          history.push('/profile')
        }
      }
  }, [signOut, history])


  const radioAllSelect = useCallback(() => {
    setListBusinessToFilter(listAllBusinessCodes)
  }, [listAllBusinessCodes])


  const radioIndividualSelect = useCallback((listBusiness) => {
    setListBusinessToFilter(listBusiness)
  }, [])


  const radioRegionSelect = useCallback((listBusiness) => {
    setListBusinessToFilter(listBusiness)
  }, [])


  const applyingPreferences = useCallback((radioButtonSelected, listBusiness = null) => {
    switch(radioButtonSelected){
      case 0:
        radioAllSelect()
        break
      case 1:
        radioIndividualSelect(listBusiness)
        break
      case 2:
        radioRegionSelect(listBusiness)
        break
      default:
        break
    }
  }, [radioAllSelect, radioIndividualSelect, radioRegionSelect])


  const removingFromArrayBusiness = useCallback((listId) => {
      let arrayCopy = [...listBusinessToFilter]
      let filteredArray = arrayCopy.filter(code => !listId.some(id => code === id))

      if(filteredArray.length === 0){
        toast.error('Não é possível remover todas as empresas')
        return
      }

      setListBusinessToFilter(filteredArray)
  }, [listBusinessToFilter])


  useEffect(() => {

    getBusinessAdm(true, 20)

  }, [getBusinessAdm])


  useEffect(() => {

    getDashboardButtons()

  }, [getDashboardButtons])
  

  useEffect(() => {
    setQuantityBusinessToFetch(businessAdm.length)
  }, [businessAdm])

  
  return(
      <AdministrativePanelContext.Provider 
        value={ { 
          isLoading, 
          loadingButtonSeeMore, setLoadingButtonSeeMore,
          businessAdm, setBusinessAdm,
          informationsToShowInPage, 
          openSideBar,
          openSubMenu,
          openDrop,
          quantityBusinessToFetch,
          nextPage,
          listAllBusinessCodes,
          setOpenSideBar,
          setOpenSubMenu,
          setOpenDrop,
          setInformationsToShowInPage,
          getBusinessAdm,
          applyingPreferences,
          listDashboardButtons,
          syncInformations, setSyncInformations,
          listBusinessToFilter, setListBusinessToFilter,
          informationsFiltered, setInformationsFiltered,
          radioButton, setRadioButton,
          startDate, setStartDate,
          endDate, setEndDate,
          removingFromArrayBusiness,
          typeDateSelected, setTypeDateSelected,
          listSalesChannelsId, setListSalesChannelsId,
          franchiseListCodesSelected, setFranchiseListCodesSelected,
          allFranchiseListCodes, setAllFranchiseListCodes,
          franchiseList
        } }
      >
         { children }
      </AdministrativePanelContext.Provider>
   )
}


export function useAdministrativeContext() {
   const context = useContext(AdministrativePanelContext)

   if(!context) {
    throw new Error('useAdministrativeContext must be used within an Provider');
  } 

   return context
}
